import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import {
  getAnnouncementAPI,
  getExposureTableAPI,
} from "../../service/AuthService";
import { useDispatch, useSelector } from "react-redux";
import { getUserDataAPI } from "../../service/UserService";
import { useQueries, useQuery } from "react-query";
import { Modal } from "react-bootstrap";
import moment from "moment";

function Header() {
  const location = useLocation();
  const userData = useSelector((state) => state.account.userData);
  const dispatch = useDispatch();
  const [announcement, setAnnouncement] = useState();
  const [exposureTableModal, setExposureTableModal] = useState(false);
  const [state, setState] = useState({
    right: false,
  });

  const navigate = useNavigate();
  const getAnnouncement = async () => {
    try {
      const { response, code } = await getAnnouncementAPI();
      if (code == 200) {
        setAnnouncement(response.announcement);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getUserData = async () => {
    try {
      var { response, code } = await getUserDataAPI(userData.id);
      if (code === 200) {
        dispatch({
          type: "accountData/setUserProfile",
          payload: response,
        });
      } else {
        dispatch({
          type: "gameData/logOut",
          payload: {},
        });
      }
    } catch (e) {
      dispatch({
        type: "accountData/logOut",
        payload: {},
      });

      localStorage.clear();
      localStorage.removeItem("user");
      localStorage.removeItem("state");
      navigate("/");
      window.location.reload();
    }
  };

  const announcementQuery = useQuery("announcement", getAnnouncement, {
    refetchInterval: 9000,
  });
  const userDataQuery = useQuery("userData", getUserData, {
    refetchInterval: 3000,
  });
  useEffect(() => {
    if (userData) {
      userDataQuery.refetch();
    }
    if (announcement) {
      announcementQuery.refetch();
    }
  }, []);

  if (!userData.token) {
    return (window.location.href = "/");
  }
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      className=""
      id="offcanvasNavbar-expand-navbar"
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div variant="white" className="offcanvas-header">
        <a href="/dashboard" className="logo">
          <img
            style={{
              width: "60px",
              height: "60px",
              objectFit: "cover",
            }}
            src={require("../../assets/logo.png")}
            alt=""
          />
        </a>
        <button type="button" className="btn-close" aria-label="Close" />
      </div>
      <div className="offcanvas-body">
        <div className="justify-content-end flex-grow-1 pe-3 navbar-nav">
          <Link to="/dashboard" className="active nav-link">
            HOME
          </Link>
          <Link to="/in-play" className="nav-link">
            IN PLAY
          </Link>

          <Link to="/password" className="nav-link">
            PASSWORD
          </Link>
          <Link to="/ledger" className="nav-link">
            LEDGER
          </Link>
          <Link to="/rules" className="nav-link">
            RULES
          </Link>
          <Link to="/casino" className="nav-link">
            CASINO
          </Link>

          <a
            onClick={() => {
              dispatch({
                type: "accountData/logOut",
                payload: {},
              });
              dispatch({
                type: "gameData/logOut",
                payload: {},
              });
              localStorage.clear();

              window.location.href = "/";
            }}
            className="nav-link"
          >
            LOGOUT
          </a>
        </div>
      </div>
    </Box>
  );

  return (
    <header>
      <div
        className="row nav-bar sticky"
        style={{ width: "100%", margin: 0, minHeight: 50 }}
      >
        <div className="col-xs-3 col-md-3  col-lg-3">
          <a href="/" />
          <a href="/">
            <img
              style={{
                width: "80px",
                height: "auto",
                objectFit: "contain",
              }}
              src={require("../../assets/logo.png")}
              alt=""
            />
          </a>
        </div>
        <div
          className="col-xs-6 col-md-6  col-lg-6 user-info"
          style={{ textAlign: "center" }}
        >
          <div>{userData?.username}</div>
          <div className="user-chips">Chips : {userData?.balance}</div>
          <div className="user-liability">Expo : {userData?.liability}</div>
        </div>
        <div
          className="col-xs-3 col-md-3  col-lg-3"
          style={{ textAlign: "right" }}
        >
          <a
            onClick={() => {
              window.localStorage.clear();

              dispatch({
                type: "accountData/logOut",
                payload: {},
              });
              setTimeout(() => {
                window.location.href = "/";
              }, 1000);
            }}
          >
            <label htmlFor="username">
              <svg
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className="svg-icon"
                style={{
                  fontSize: 30,
                  width: "1em",
                  height: "1em",
                  verticalAlign: "middle",
                  fill: "currentcolor",
                  overflow: "hidden",
                }}
              >
                <path
                  d="M128 213.333333c0-46.933333 38.4-85.333333 85.333333-85.333333h341.333334v85.333333H213.333333v597.333334h341.333334v85.333333H213.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333V213.333333z m604.842667 256L624.64 361.130667l60.330667-60.330667 211.2 211.2-211.2 211.2-60.330667-60.330667L732.842667 554.666667H451.84v-85.333334h281.002667z"
                  fill="#fff"
                />
              </svg>
            </label>
          </a>
        </div>
      </div>
    </header>
  );
}
export default Header;
